
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/banking-academy",
      function () {
        return require("private-next-pages/case-study/banking-academy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/banking-academy"])
      });
    }
  